<template>
    <div class='container-rating'>

        <img :alt="user.full_name" :src="user.profile_picture" class="img-circle img-responsive img-rating">
        
        <div class="container-rating flex-row justify-content-center align-items-center">
            <div class="card p-md" style="padding: 0px 40px;">

                <div class="flex-star">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="review-count">{{ getReviewCount() }} Avaliações</h5>
                        </div>
                        <div class="col-6">
                            <ul class="avaliation" :class="{ 'ranking-ativo': geral >= 1 }">
                                <li class="star-icons total" :class="{ 'ativo': geral == 1 }"></li>
                                <li class="star-icons total" :class="{ 'ativo': geral == 2 }"></li>
                                <li class="star-icons total" :class="{ 'ativo': geral == 3 }"></li>
                                <li class="star-icons total" :class="{ 'ativo': geral == 4 }"></li>
                                <li class="star-icons total" :class="{ 'ativo': geral == 5 }"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="flex-star">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="review-stat">Desempenho</h5>
                        </div>
                        <div class="col-6">
                            <ul class="small-avaliation" :class="{ 'ranking-ativo': desempenho >= 1 }">
                                <li class="star-icons desempenho" :class="{ 'ativo': desempenho == 1 }"></li>
                                <li class="star-icons desempenho" :class="{ 'ativo': desempenho == 2 }"></li>
                                <li class="star-icons desempenho" :class="{ 'ativo': desempenho == 3 }"></li>
                                <li class="star-icons desempenho" :class="{ 'ativo': desempenho == 4 }"></li>
                                <li class="star-icons desempenho" :class="{ 'ativo': desempenho == 5 }"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="flex-star">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="review-stat">Atendimento</h5>
                        </div>
                        <div class="col-6">
                            <ul class="small-avaliation" :class="{ 'ranking-ativo': atendimento >= 1 }">
                                <li class="star-icons atendimento" :class="{ 'ativo': atendimento == 1 }"></li>
                                <li class="star-icons atendimento" :class="{ 'ativo': atendimento == 2 }"></li>
                                <li class="star-icons atendimento" :class="{ 'ativo': atendimento == 3 }"></li>
                                <li class="star-icons atendimento" :class="{ 'ativo': atendimento == 4 }"></li>
                                <li class="star-icons atendimento" :class="{ 'ativo': atendimento == 5 }"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="flex-star">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="review-stat">Prazo</h5>
                        </div>
                        <div class="col-6">
                            <ul class="small-avaliation" :class="{ 'ranking-ativo': prazo >= 1 }">
                                <li class="star-icons prazo" :class="{ 'ativo': prazo == 1 }"></li>
                                <li class="star-icons prazo" :class="{ 'ativo': prazo == 2 }"></li>
                                <li class="star-icons prazo" :class="{ 'ativo': prazo == 3 }"></li>
                                <li class="star-icons prazo" :class="{ 'ativo': prazo == 4 }"></li>
                                <li class="star-icons prazo" :class="{ 'ativo': prazo == 5 }"></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="open-modal-button">

                    <a v-if='getReviewCount() > 0' data-toggle="modal" :data-target="'#'+modal_id">
                        Ver tudo
                    </a>

                    <a v-else>
                        Sem avaliações
                    </a>

                </div>

            </div> 
        
            <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title" id="modalLabel">Avaliações</h4>
                        </div>

                        <div class="modal-body" style="overflow-y: scroll; max-height: 500px;">
                                        
                            <div v-for="avaliacao in ratings" class="container-coment">

                                <div class="rating-container flex-row justify-content-center align-items-center">
                                    <div class="card-sm padding-r">
        
                                        <div class="mt-5 flex-row justify-content-between align-items-center">
                                            <h5 class="review-stat-modal">Desempenho</h5>
                                            <div class="small-ratings">
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.performance >= 1 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.performance >= 2 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.performance >= 3 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.performance >= 4 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.performance >= 5 }"></i>
                                            </div>
                                            
                                        </div>

                                        <div class="mt-1 flex-row justify-content-between align-items-center">
                                            <h5 class="review-stat-modal">Atendimento</h5>
                                            <div class="small-ratings">
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.service >= 1 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.service >= 2 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.service >= 3 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.service >= 4 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.service >= 5 }"></i>
                                            </div>
                                        </div>


                                        <div class="mt-1 flex-row justify-content-between align-items-center">
                                            <h5 class="review-stat-modal">Prazo</h5>
                                            <div class="small-ratings">
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.delivery_time >= 1 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.delivery_time >= 2 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.delivery_time >= 3 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.delivery_time >= 4 }"></i>
                                                <i class="fa fa-star" :class="{ 'rating-color': avaliacao.delivery_time >= 5 }"></i>
                                            </div>
                                        </div>
        
                                    </div> 
                                </div> 

                                <div>
                                    <label>Comentário</label>
                                    <textarea cols="50" rows="4" class="form-control" disabled placeholder="Nenhum Comentário" :value="avaliacao.comments"></textarea>
                                </div>

                            </div>

                        </div>
                        
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        </div>

                    </div>
                </div>
            </div>
            
        </div>
    
    </div>

</template>

<script>
export default {
    props:{
         user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            desempenho: 0,
            atendimento: 0,
            prazo: 0,
            geral: 0,
            modal_id: Math.random().toString(16).slice(2),
            ratings: this.user.user_bid_ratings || []
        };
    },
    methods: {
        getReviewCount() {

            if(this.user.user_bid_ratings)
                return this.user.user_bid_ratings.length || 0;
            
            return 0;

        }
    },
    mounted() {

        let length = this.getReviewCount();
        
        if(length){

            this.desempenho  = Math.round(this.user.user_bid_ratings.reduce((a, b) => a + b.performance, 0) / length);
            this.atendimento = Math.round(this.user.user_bid_ratings.reduce((a, b) => a + b.service, 0) / length);
            this.prazo       = Math.round(this.user.user_bid_ratings.reduce((a, b) => a + b.delivery_time, 0) / length);

            this.geral = Math.round((this.desempenho + this.atendimento + this.prazo) / 3);
        
        }

    }
}
</script>

<style>

    @media (max-width:500px){

        .container-rating {
            display: inherit !important;
            width: 100%;
        }

        .open-modal-button {
            margin: auto;
            display: table;
        }
    
        .flex-star {
            flex-direction: column !important;
        }

    }

    .padding-r {
        padding-right: 10px;
    }
    
    .container-rating {
        display: flex;
        flex-wrap: wrap;
    }

    .container-coment {
        display: flex;
        margin-bottom: 4vh;
    }

    .img-rating { 
        height: 130px;
        width: 130px;
        margin: auto;
    }

    .align-items-center {
        align-items: center!important;
    }
        
    .justify-content-between{
        justify-content: space-between!important;
    }

    .card-sm{
        width:220px;
        border:none;
    }
    
    .card{
        width:380px;
        border:none;
    }

    .avaliation{
        display: flex;
        position: relative;
        right: 0;
        margin-bottom: 0px !important;
        color:#cecece;
    }

    .avaliation li{
        font-size:32px;
    }

    .small-avaliation {
        display: flex;
        position: relative;
        right: 0;
        margin-bottom: 0px;
        color:#cecece;
    }

    .ranking-ativo {
        color: #ffe500;
    }

    .star-icons {
        list-style-type: none;
        font-size: 25px;
    }

    .star-icons::before {
        content: "\2605";
    }

    .star-icons.ativo ~ .star-icons::before {
        color:#cecece
    }

    .rating-color{
        color:#ffe500 !important;
    }

    .review-count{
        font-weight:400;
        font-size: 20px !important;
        margin-bottom: 0px;
        margin-top: 12px !important;
        width: 140px;
    }

    .review-stat{
        font-weight:300;
        font-size:18px;
        margin-bottom:0px;
        margin-top: 7px !important;
        width: 140px;
    }

    .review-stat-modal{
        font-weight:300;
        font-size:18px;
        margin-bottom:0px;
        margin-top: 7px !important;
        width: 120px;
    } 
     
    .flex-star {
        display: flex;
    }

</style>